import React from "react"
import { Column, Container, ContainerTypes, Row } from "@fiken/components"
import Styles from "./Hero.module.css"
import Sok from "../shared/Søk.svg?react"
import { useAppSelector } from "../../app/hooks"

export default function Hero(): React.ReactElement {
  const { isMobile } = useAppSelector((state) => state.setting)
  return (
    <Container type={ContainerTypes.XL} className={Styles.main}>
      <Row>
        <Column className={Styles.column}>
          <div>
            <h1>Gratis kontohjelp til regnskapet</h1>
            <p>
              Søk på helt vanlige ord, slik som kontorstol eller macbook, og vi forteller deg hvilken konto det skal
              føres på i regnskapet – helt gratis!
            </p>
          </div>
          {isMobile ? null : (
            <div className={Styles.figure}>
              <Sok />
            </div>
          )}
        </Column>
      </Row>
    </Container>
  )
}
